import React, {PropTypes} from 'react';
import {Field, reduxForm, FieldArray, formValueSelector} from 'redux-form';
import {Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import axios from './../../../constants/axios';
import SelectAsync from './../../FormTemplate/SelectAsync';
import Select from './../../FormTemplate/Select';
import TextareaControl from './../../FormTemplate/TextareaControl';
import RenderLists from './Helper/RenderLists';

class NewPurchaseForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         vendorAddresses: []
      };
   }

   componentWillReceiveProps(nextProps) {
      if (nextProps.contact_id && (typeof nextProps.contact_id === 'number') && nextProps.contact_id !== this.props.contact_id) {
         axios.get(`contacts/${nextProps.contact_id}/getAddresses`)
            .then((res) => {
               let n = res.data.map((add) => {
                  return {
                     value: add.id,
                     label: `${add.address} | ${add.contact_address_type_name}`
                  };
               });
               this.setState({
                  vendorAddresses: n
               });
            });
      }
      if (nextProps.items && nextProps.items.length > 0) {
         nextProps.items.forEach((item) => {
            if (item.total && item.unit) {
               item.price = (item.total / item.unit).toFixed(5);
            } else {
               item.price = '';
            }
         });
      }
   }

   render() {
      const {handleSubmit, submit, items, submitting, pristine, invalid} = this.props;
      const total = function () {
         let subTotal = 0;
         if (items && items.length > 0) {
            items.forEach((item) => {
               subTotal += (item.unit || 0) * (item.price || 0);
            });
         }
         return subTotal.toFixed(5);
      };
      const {vendorAddresses} = this.state;
      return (
         <form noValidate autoComplete="off" onSubmit={(e) => this.handleKeyDown(e)}>
            <div className="row">
               <div className="col-md-6">
                  <Field name="contact_id" minimumInput={2} component={SelectAsync} link="contacts/vendors/searchByName"
                         label="Vendor Name"/>
               </div>
               <div className="col-md-6">
                  <Field name="contact_address_id" allowEmpty={true} component={Select} options={vendorAddresses}
                         label="Vendor Address"/>
               </div>
            </div>
            <FieldArray items={items} name="items" component={RenderLists}/>

            <hr/>
            <p className="pull-right">Total: {total()}</p>
            <hr/>

            <Field name="memo" label="Memo" component={TextareaControl}/>
            <Button type="button" bsStyle="success" block
                    onClick={handleSubmit(submit)}
                    disabled={submitting || pristine || invalid}>Save</Button>
         </form>
      );
   }
}

NewPurchaseForm.propTypes = {
   handleSubmit: PropTypes.func,
   submit: PropTypes.func,
   items: PropTypes.array,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   contact_id: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.number
   ])
};

NewPurchaseForm = reduxForm({ // eslint-disable-line
   form: 'inventoryPurchaseForm'
})(NewPurchaseForm);

NewPurchaseForm.contextTypes = {
   router: PropTypes.object
};

const selector = formValueSelector('inventoryPurchaseForm');

NewPurchaseForm = connect(state => { // eslint-disable-line
   const items = selector(state, 'items');
   const contact_id = selector(state, 'contact_id');
   return {
      items,
      contact_id
   };
})(NewPurchaseForm);


export default NewPurchaseForm;






/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/NewPurchaseForm.js
 **/